import React, {Component} from 'react';

export class DecimalInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };

        this.handleValueChange = this.handleValueChange.bind(this);
    }

    handleValueChange(event) {
        let newValue = event.target.value.replaceAll(",","").replace(".", ",");
        newValue = this.addZeroIfLastCharacterIsDot(newValue);

        const possibleNewValue = parseFloat(newValue);
        if(isNaN(possibleNewValue) && newValue !== "") {
            return;
        }

        newValue = event.target.value.replaceAll(",","");
        this.setState({value: newValue});
        this.props.onChange(newValue);
    }

    addZeroIfLastCharacterIsDot(newValue) {
        if (this.lastCharacterIsADot(newValue)) {
            newValue += "0";
        }
        return newValue;
    }

    lastCharacterIsADot(newValue) {
        return newValue !== null && newValue !== undefined && newValue.length > 1 && newValue.charAt(newValue.length - 1) === ".";
    }

    render() {
        let formattedValue = this.state.value;
        if (this.state.value !== null && this.state.value !== "") {
            let aux = this.addZeroIfLastCharacterIsDot(this.state.value)
            if(this.state.value === "0.0") {
                formattedValue = aux;
            }
            else {
                formattedValue = parseFloat(aux).toLocaleString('en-US');
                formattedValue += this.lastCharacterIsADot(this.state.value) ? "." : "";
            }
        }

        return (
            <input
                name={this.props.name}
                type="text"
                className="form-control"
                readOnly={this.props.readOnly}
                id={this.props.name}
                value={formattedValue}
                onChange={this.handleValueChange}
            />
        );
    }
}
